import brandTokens from './brand-tokens.json';

/** ECGrid brand palette — hex values sourced from brand-tokens.json (single source of truth) */
export const ECGridColors = {
  blue: brandTokens.primary,
  tealDark: brandTokens.dark,
  navy: brandTokens.navy,
  blueGray: brandTokens['silver-blue'],
  red: brandTokens.red,
  yellowDark: brandTokens.olive,
  yellowLight: brandTokens['yellow-green'],
} as const;

/** ECGrid text colors per UI Standards Guide section 03 */
export const ECGridTextColors = {
  primary: brandTokens['body-primary'],
  secondary: brandTokens['body-secondary'],
  tertiary: brandTokens['body-tertiary'],
  link: brandTokens.dark,
  onDark: '#ffffff', // white — intentionally not in brand-tokens.json (universal)
} as const;

export type ECGridColorKey = keyof typeof ECGridColors;
export type ECGridColorValue = (typeof ECGridColors)[ECGridColorKey];
